import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { useTour } from '@/shared/lib/hooks';

export const TourTriggerMenuItem = memo(() => {
    const { t } = useTranslation();
    const { setIsOpen, setCurrentStep, steps } = useTour();

    const handleClick = () => {
        if (setCurrentStep && setIsOpen) {
            setCurrentStep(0);
            setIsOpen(true);
        }
    };

    if (!steps || steps.length === 0) {
        return null;
    }

    return (
        <div
            onClick={handleClick}
            style={{ cursor: 'pointer' }}
        >
            {t('startTour')}
        </div>
    );
});

TourTriggerMenuItem.displayName = 'TourTriggerMenuItem';
